import { render, staticRenderFns } from "./GridResponsiveLayout.vue?vue&type=template&id=760cdcd6&"
import script from "./GridResponsiveLayout.vue?vue&type=script&lang=js&"
export * from "./GridResponsiveLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports